import environment from 'constants/environments';
import { InsType } from './../constants/enums/insType.enum';
import sweetAlertService from 'utils/sweetAlertService';
import storageService from './storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import { Premission } from 'constants/enums/premission.enum';
import { LinkTarget } from 'constants/enums/linkTarget.enum';
import { BaseReq } from 'bff/models/base/baseReq';
import { AxiosRequestConfig } from 'axios';
import { ApplicationId } from 'constants/enums/applicationId.enum';
import { SysOption, Code, Postcode, AreaContent, Occupation } from 'bff/models/info';
import * as FileSaver from 'file-saver';
import { BaseLink } from 'bff/models/link';
import _ from 'lodash';
import { Favorite, AddFavoriteItem, MemberProfile } from 'bff/models/member';
import { EvalRes, HeaderContent, BodyContent, FooterContent } from 'bff/models/product';
import { ExpanHeaderContent, ExpanFooterContent, ExpanBodyContent, EvalExpans, ExpanBodyBaseContent } from 'constants/models/evalExpans';
import { EvalInfoBodyType } from 'constants/enums/evalIfnoBodyType.enum';
// import moment from 'moment';
import moment from 'moment-timezone';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';
import { RouterSettings } from 'constants/models/routerSettings';
import { InsureProcessTemp } from 'constants/models/insureProcessTemp';
import { TermStatus } from 'constants/models/termStatus';
import { mobileRegex, emailRegex } from 'utils/commonValidations';
import { ResourcesState } from 'redux/reducers/components/resources.reducer';
// 源碼檢測風險議題
// 搭配 ts v3.8: 主要套件 dompurify 為 ~2.3.12 (鎖定第 2 碼，舊版內建 domutils)、
//              相依套件 @types/dompurify 鎖定 2.3.3 (對應 ts v3.8)、
//              相依套件 @types/domutils 鎖定 1.7.4 (對應 ts v3.8)
// 源碼檢測風險議題 (2024/08/09)
import DOMPurify from 'dompurify';
import ReactHtmlParser from 'react-html-parser';
import { CodeId } from 'constants/enums/codeId.enum';
import { Rule } from './types';
import store from 'redux/store';
import { InsCount } from 'constants/enums/insCount.enum';
import { TravelPlanType } from 'constants/enums/travelPlanType.enum';
import { SysOptType } from 'constants/enums/sysOptType.enum';
import { OccupationIdType } from 'constants/enums/occupationIdType.enum';

const whiteUrls = [
  'https://www.wwunion.com/'
];

/**
 * @description 前端商品連動規則
 */
const frontendRules: Rule[] = [
  /** CR 導入時間: 2024/03/14 */
  {
    ruleId: '33A_33B_SELECTION',
    ruleDesc: '第三人責任險 33A、33B 項目連動規則',
    mainItems: ['31', '32', '31E0', '32E0'],
    subItems: ['33A', '33B'],
    additionalTerms: [],
    mapping: [],
    applied: false
  },
  /** CR 導入時間: 2022/11/09 */
  {
    ruleId: '88C_SERIES_ITEM_HIDDEN',
    ruleDesc: '車體險 88C 系列隱藏規則',
    mainItems: ['01', '05', '07', '11', '01E0', '05E0', '07E0', '11E0', '67A', '67B'],
    subItems: [],
    additionalTerms: ['88C1', '88C5', '88C7', '17C'],
    /** 一對一關聯 */
    mapping: [
      {
        mainId: '01',
        additionalId: '88C1'
      },
      {
        mainId: '05',
        additionalId: '88C5'
      },
      {
        mainId: '07',
        additionalId: '88C7'
      },
      {
        mainId: '11',
        additionalId: '17C'
      },
      {
        mainId: '01E0',
        additionalId: '88C1'
      },
      {
        mainId: '05E0',
        additionalId: '88C5'
      },
      {
        mainId: '07E0',
        additionalId: '88C7'
      },
      {
        mainId: '11E0',
        additionalId: '17C'
      }
    ]
  },
  /** 原始功能抽出: 2024/07/31 */
  {
    ruleId: '31_31E0_CLEAR_CHECKING',
    ruleDesc: '第三人責任險 31、31E0 倍數清除判斷規則',
    mainItems: ['31', '31E0'],
    subItems: [],
    additionalTerms: [],
    mapping: []
  },
  /** 原始功能抽出與調整: 2024/01/17（取消 34A1 與 31 的連動） */
  {
    ruleId: '36A_HIGHLIGHT',
    ruleDesc: '第三人責任險 36A 滾動至主約判斷規則',
    mainItems: ['31', '31E0'],
    subItems: ['36A'],
    additionalTerms: [],
    mapping: []
  },
  /** 原始功能抽出: 2024/07/31 */
  {
    ruleId: '56M_57M_HIGHLIGHT',
    ruleDesc: '第三人責任險 56M、57M 滾動至主約判斷規則',
    mainItems: ['56', '57'],
    subItems: ['56M', '57M'],
    additionalTerms: [],
    mapping: [],
    codeId01: CodeId.W039,
    codeId02: CodeId.W041
  },
  /** 原始功能抽出: 2024/07/31 */
  {
    ruleId: '65M_HIGHLIGHT',
    ruleDesc: '第三人責任險 65M 滾動至主約判斷規則',
    mainItems: ['65'],
    subItems: ['65M'],
    additionalTerms: [],
    mapping: [],
    codeId01: CodeId.W040
  }
];

/**
 * @description Check if http-response is success
 * @param doAlert if true, `sweet-alert` fire when response not success
 * @param customMsg show this custom message when response not success
 */
const isHttpRespSuccess = (res: any, doAlert = true, customMsg = ''): boolean => {
  if (doAlert) {
    try {
      switch (res.status) {
        case environment.getSuccessCode:
          break;
        default:
          // SweetAlert Return Desc
          break;
      }
    } catch {
      sweetAlertService.info('', customMsg || '系統發生錯誤，請稍後再試，如有疑問請洽客服。');
      return false;
    }
  }
  return res.status === environment.getSuccessCode || res.status === environment.postSuccessCode;
};

/**
 * @description 檢核導頁網址是否需要先登入，未登入:導至登入路由，已登入:導至目標路由
 * @param loginRequired 是否需要登入
 * @param originUrl 目標路由
 */
const validLoginState = (loginRequired: string, originUrl: string): string => {
  const isNeedLogin: boolean =
    loginRequired === Premission.LoginRequired &&
    !storageService.getItem(storageKeys.LoginInfo);

  if (isNeedLogin) { return RouterSettings.Login; }

  return originUrl;
};

/**
 * @description 取得開啟路由的方式
 * @param isNeedNewWindow 是否需要開啟新頁
 */
const getLinkTarget = (isNeedNewWindow: string): string => {
  return isNeedNewWindow === LinkTarget.NewWindow ? '_blank' : '_self';
};

/**
 * @description 檢核導頁網址是否需要先登入，未登入:導至登入路由，已登入:導至目標路由
 * @param e 觸發路由事件 element
 * @param link 路由 model
 * @param 路由 props.history.push 方法
*/
const validRedirect = (link: BaseLink, e?: React.MouseEvent<HTMLAnchorElement>, pushRouter?: any) => {
  if (e) e.preventDefault();

  const isNeedLogin: boolean = link.LOGIN_REQUIRED === Premission.LoginRequired &&
    !storageService.getItem(storageKeys.LoginInfo);

  if (isNeedLogin && pushRouter) {
    const path = {
      pathname: RouterSettings.Login,
      state: { preUrl: link.URL }
    };

    pushRouter(path);

    return;
  }

  if (link.URL.indexOf('http') === -1) {
    pushRouter(link.URL);
    return;
  }

  if (link.NEW_WINDOW === LinkTarget.NewWindow) {
    window.open(link.URL);
    return;
  }

  // props.history.push(childLink.URL);
  window.location.href = link.URL;
};

/**
   * @description 依會員登入狀態進行我的收藏與貼心推薦項目匹配，開啟愛心圖示
   * @param favorites 登入後的我的收藏資料
   * @param insTypeId 險種類別
   * @param prodId 商品代碼
   * @param planId 計畫代碼
   */
const matchFavorite = (favorites: Favorite[], insTypeId: string, prodId: string, planId: string) => {
  if (favorites && favorites.length > 0) {
    return _.findIndex(favorites, (favoriteItem: any) => {
      return favoriteItem.INS_TYPE_ID === insTypeId && favoriteItem.PROD_ID === prodId && favoriteItem.PLAN_ID === planId;
    }) !== -1;
  }
};

/**
 * @description 取得刪除我的收藏用鍵
 * @param favorites 登入後的我的收藏資料
 * @param insTypeId 險種類別
 * @param prodId 商品代碼
 * @param planId 計畫代碼
 */
const getFavoriteItemSN = (favorites: Favorite[], insTypeId: string, prodId: string, planId: string) => {
  if (!storageService.getItem(storageKeys.LoginInfo)) return planId;

  if (favorites.length <= 0) return;

  const favoriteItem = _.find(favorites, (favorite: Favorite) => {
    return favorite.INS_TYPE_ID === insTypeId && favorite.PROD_ID === prodId && favorite.PLAN_ID === planId;
  });

  return favoriteItem?.SN;
};

/**
 * @description 取得新增我的收藏 Model
 * @param insTypeId 險種類別
 * @param prodId 商品代碼
 * @param planId 計畫代碼
*/
const getAddFavoriteItem = (insTypeId: string, prodId: string, planId: string) => {
  const addFavoriteItem: AddFavoriteItem = {
    MEMBER_ID: storageService.getItem(storageKeys.MemberId),
    INS_TYPE_ID: insTypeId,
    PROD_ID: prodId,
    PLAN_ID: planId
  };

  return addFavoriteItem;
};

/**
   * @description 排序系統參數類別資料
  */
const sortSysOpts = (sysOpts: SysOption[]) => {
  const sysOptions = sysOpts.sort((first: SysOption, second: SysOption) => {
    if ((first && first.PARAM_ORDER) && (second && second.PARAM_ORDER)) {
      return +first.PARAM_ORDER - +second.PARAM_ORDER;
    }
    return 0;
  });

  return sysOptions;
};

/**
 * @description 下載檔案
 * @param fileData 要下載的檔案資訊 blob、url、File
 * @param fileName 檔案名稱
*/
const downloadFile = (fileData: any, fileName: string) => {
  FileSaver.saveAs(fileData, fileName);
};

/**
 * @description 攤平投保作業-保費試算頁結果資料
*/
const expandEvalResult = (evalInfo: EvalRes) => {
  if (evalInfo) {
    const tempHeaders: ExpanHeaderContent[] = [];
    const tempFooters: ExpanFooterContent[][] = [];
    const tempBodys: ExpanBodyContent[][] = [];
    const tempBodysO15: ExpanBodyContent[][] = [];
    const tempBodysU15: ExpanBodyContent[][] = [];
    const subTotalO15: ExpanBodyBaseContent[][] = [];
    const subTotalU15: ExpanBodyBaseContent[][] = [];

    // #region 攤平 header
    _.forEach(evalInfo.EVAL_RESULT.HEADER, (headers: HeaderContent[]) => {
      for (let i = 1; i < headers.length; i += 1) {
        tempHeaders.push({
          MAINTITLE: headers[0].TITLE,
          PLAN_ID: headers[i].PLAN_ID,
          SUBTITLE: headers[i].SUBTITLE,
          TITLE: headers[i].TITLE,
          TOTAL: headers[i].TOTAL
        });
      }
    });
    // #endregion

    // #region 攤平-body
    let bodyCount = 0;
    while (bodyCount < tempHeaders.length) {
      const position = bodyCount;
      const tempBodyArray: ExpanBodyContent[] = [];
      _.forEach(evalInfo.EVAL_RESULT.BODY, (bodys: BodyContent) => {
        switch (bodys.TYPE) {
          case EvalInfoBodyType.ROW: {
            tempBodyArray.push({
              TYPE: bodys.TYPE,
              ROWTITLE: bodys.ROWTITLE,
              FIELD: bodys.FIELD[position]
            });
            break;
          }
          case EvalInfoBodyType.FOLDABLE: {
            const tempBodyContentArrar: ExpanBodyContent[] = [];
            _.forEach(bodys.BODY, (bodyContents: BodyContent) => {
              tempBodyContentArrar.push({
                TYPE: bodyContents.TYPE,
                ROWTITLE: bodyContents.ROWTITLE,
                FIELD: bodyContents.FIELD[position]
              });
            });
            tempBodyArray.push({
              TYPE: bodys.TYPE,
              ROWTITLE: bodys.ROWTITLE,
              BODY: [...tempBodyContentArrar]
            });
            break;
          }
        }
      });
      tempBodys.push(tempBodyArray);
      bodyCount += 1;
    }

    let bodyCountO15 = 0;
    while (bodyCountO15 < tempHeaders.length) {
      const position = bodyCountO15;
      const tempBodyArray: ExpanBodyContent[] = [];
      _.forEach(evalInfo.EVAL_RESULT.BODY_O15, (bodys: BodyContent) => {
        switch (bodys.TYPE) {
          case EvalInfoBodyType.ROW: {
            tempBodyArray.push({
              TYPE: bodys.TYPE,
              ROWTITLE: bodys.ROWTITLE,
              FIELD: bodys.FIELD[position]
            });
            break;
          }
          case EvalInfoBodyType.FOLDABLE: {
            const tempBodyContentArrar: ExpanBodyContent[] = [];
            _.forEach(bodys.BODY, (bodyContents: BodyContent) => {
              tempBodyContentArrar.push({
                TYPE: bodyContents.TYPE,
                ROWTITLE: bodyContents.ROWTITLE,
                FIELD: bodyContents.FIELD[position]
              });
            });
            tempBodyArray.push({
              TYPE: bodys.TYPE,
              ROWTITLE: bodys.ROWTITLE,
              BODY: [...tempBodyContentArrar]
            });
            break;
          }
        }
      });
      tempBodysO15.push(tempBodyArray);
      bodyCountO15 += 1;
    }

    let subTotalCountO15 = 0;
    while (subTotalCountO15 < tempHeaders.length) {
      const position = subTotalCountO15;
      const tempBodyArray: ExpanBodyContent[] = [];
      _.forEach(evalInfo.EVAL_RESULT.SUBTOTAL_O15[0], (bodys: BodyContent) => {
        switch (bodys.TYPE) {
          case EvalInfoBodyType.ROW: {
            tempBodyArray.push({
              TYPE: bodys.TYPE,
              ROWTITLE: bodys.ROWTITLE,
              FIELD: bodys.FIELD[position]
            });
            break;
          }
          case EvalInfoBodyType.FOLDABLE: {
            const tempBodyContentArrar: ExpanBodyContent[] = [];
            _.forEach(bodys.BODY, (bodyContents: BodyContent) => {
              tempBodyContentArrar.push({
                TYPE: bodyContents.TYPE,
                ROWTITLE: bodyContents.ROWTITLE,
                FIELD: bodyContents.FIELD[position]
              });
            });
            tempBodyArray.push({
              TYPE: bodys.TYPE,
              ROWTITLE: bodys.ROWTITLE,
              BODY: [...tempBodyContentArrar]
            });
            break;
          }
        }
      });
      subTotalO15.push(tempBodyArray);
      subTotalCountO15 += 1;
    }

    let subTotalCountU15 = 0;
    while (subTotalCountU15 < tempHeaders.length) {
      const position = subTotalCountU15;
      const tempBodyArray: ExpanBodyContent[] = [];
      _.forEach(evalInfo.EVAL_RESULT.SUBTOTAL_U15[0], (bodys: BodyContent) => {
        switch (bodys.TYPE) {
          case EvalInfoBodyType.ROW: {
            tempBodyArray.push({
              TYPE: bodys.TYPE,
              ROWTITLE: bodys.ROWTITLE,
              FIELD: bodys.FIELD[position]
            });
            break;
          }
          case EvalInfoBodyType.FOLDABLE: {
            const tempBodyContentArrar: ExpanBodyContent[] = [];
            _.forEach(bodys.BODY, (bodyContents: BodyContent) => {
              tempBodyContentArrar.push({
                TYPE: bodyContents.TYPE,
                ROWTITLE: bodyContents.ROWTITLE,
                FIELD: bodyContents.FIELD[position]
              });
            });
            tempBodyArray.push({
              TYPE: bodys.TYPE,
              ROWTITLE: bodys.ROWTITLE,
              BODY: [...tempBodyContentArrar]
            });
            break;
          }
        }
      });
      subTotalU15.push(tempBodyArray);
      subTotalCountU15 += 1;
    }

    let bodyCountU15 = 0;
    while (bodyCountU15 < tempHeaders.length) {
      const position = bodyCountU15;
      const tempBodyArray: ExpanBodyContent[] = [];
      _.forEach(evalInfo.EVAL_RESULT.BODY_U15, (bodys: BodyContent) => {
        switch (bodys.TYPE) {
          case EvalInfoBodyType.ROW: {
            tempBodyArray.push({
              TYPE: bodys.TYPE,
              ROWTITLE: bodys.ROWTITLE,
              FIELD: bodys.FIELD[position]
            });
            break;
          }
          case EvalInfoBodyType.FOLDABLE: {
            const tempBodyContentArrar: ExpanBodyContent[] = [];
            _.forEach(bodys.BODY, (bodyContents: BodyContent) => {
              tempBodyContentArrar.push({
                TYPE: bodyContents.TYPE,
                ROWTITLE: bodyContents.ROWTITLE,
                FIELD: bodyContents.FIELD[position]
              });
            });
            tempBodyArray.push({
              TYPE: bodys.TYPE,
              ROWTITLE: bodys.ROWTITLE,
              BODY: [...tempBodyContentArrar]
            });
            break;
          }
        }
      });
      tempBodysU15.push(tempBodyArray);
      bodyCountU15 += 1;
    }

    // #endregion

    // #region 攤平-footer
    let footerCount = 0;
    while (footerCount < tempHeaders.length) {
      const position = footerCount + 1;
      const tempFooterArray: ExpanFooterContent[] = [];
      _.forEach(evalInfo.EVAL_RESULT.FOOTER, (footers: FooterContent[], footersIndex: number) => {
        tempFooterArray.push(
          {
            TITLE: footers[0].TITLE,
            TOTAL: footers[position].SUBTOTAL || footers[position].TOTAL
          }
        );
      });
      tempFooters.push(tempFooterArray);
      footerCount += 1;
    }

    // #endregion

    const tempCalcRes: EvalExpans[] = [];
    for (let i = 0; i < tempHeaders.length; i += 1) {
      tempCalcRes.push({
        INS_TYPE_ID: evalInfo.EVAL_RESULT.INS_TYPE_ID,
        PROD_ID: evalInfo.EVAL_RESULT.PROD_ID,
        HEADER: { ...tempHeaders[i] },
        BODY: [...tempBodys[i]],
        BODY_O15: [...tempBodysO15[i]],
        BODY_U15: [...tempBodysU15[i]],
        SUBTOTAL_O15: [...[subTotalO15][0][i]],
        SUBTOTAL_U15: [...[subTotalU15][0][i]],
        FOOTER: [...tempFooters[i]]
      });
    }

    return tempCalcRes;
  }
};

const getSubjectPClass = (prodId: string, insCount: string) => {
  if (prodId === TravelPlanType.NTAG && insCount === InsCount.One) {
    return SysOptType.SGSUBJECTO;
  }
  if (prodId === TravelPlanType.NTAG && insCount === InsCount.MORE) {
    return SysOptType.SGSUBJECTM;
  }
  if ((prodId === TravelPlanType.Abroad || prodId === TravelPlanType.Domestic) && insCount === InsCount.One) {
    return SysOptType.INSUREDSUBJECTO;
  }
  if ((prodId === TravelPlanType.Abroad || prodId === TravelPlanType.Domestic) && insCount === InsCount.MORE) {
    return SysOptType.INSUREDSUBJECTM;
  }
};

/**
 * @description 陣列類型判斷回傳值，無值回傳空陣列
*/
const arrayTypeReturn = (arrayVal: any) => {
  if (arrayVal) {
    return [...arrayVal];
  }

  return new Array(0);
};

/**
 * @description 依 訊息代號 取得訊息值
 * @param codes 系統訊息
 * @param codeId 訊息代號
 */
const getCodeMsg = (codes?: Code[], codeId?: string) => {
  if (codes && codes.length > 0 && codeId) {
    return _.find(codes, (code: Code) => code.CODE_ID === codeId)?.CODE_VALUE as string;
  }

  return '';
};

/**
   *@description 取得系統參數顯示字
   */
const getSysOptText = (sysOpts: SysOption[], paramVal: string) => {
  return _.find(sysOpts, (sysOpt: SysOption) => sysOpt.PARAM_VALUE === paramVal)?.PARAM_TEXT;
};

/**
     * @description 格式化顯示金額，加入千分位符號
     */
const thousandFormat = (amtStr: string) => {
  if (isNaN(+amtStr)) {
    return amtStr;
  }

  return amtStr.replace(/(\d{1,3})(?=(\d{3})+$)/g, '$1,');
};

/**
 * @description 去除千分位符號
 */
const removeComma = (str: string) => {
  if (!str || str.indexOf(',') === -1) return str;

  return str.replace(/,/g, '');
};

/**
 * @description 將頁面移至最上層
 */
const scrollToTop = () => {
  window.scrollTo(0, 0);
};

/**
   * @description 取得不可投保的時間
  */
const getDisableTime = (sDate: any, sysTime?: number) => {
  const disableTimes = new Array(0);
  const today = sysTime ? moment.unix(sysTime) : moment();
  if (sDate && today.isSame(moment(sDate), 'day')) {
    for (let i = 0; i <= today.hour() + 1; i++) {
      disableTimes.push(i);
    }
  }

  // console.log({ disableTimes });
  // console.log(moment().hour());
  return disableTimes;
};

/**
 * @description 顯示錯誤提示訊息
*/
const showErrorModal = (desc: string, code: string, title: string = '執行錯誤') : Promise<any> => {
  return sweetAlertService.modal({
    icon: SweetAlertIcon.Info,
    title: title,
    html: `${desc}<br />(error code : ${code})`
  })
};

/**
 * @description 顯示公告訊息
 * @param endTime 有效時間
 * @param title 公告標題
 * @param content 公告內容
 */
const showAnnounceModal = (endTime: string, title: string = '', content: string = '') => {
  // 判斷系統日若符合公告的有效期間，顯示內容
  if (moment(endTime) > moment()) {
    sweetAlertService.modal({
      icon: SweetAlertIcon.Announce,
      title: title,
      html: content
    });
  }
};

/**
 * @description 設定 Model Select 項目的中文名稱
 * @param setFieldValue 表單設值方法
 * @param fieldName 表單 (Model) 欄位名稱
 * @param optName Select 選單中文值
 */
const setSelectOptName = (setFieldValue: any, fieldName: string, optName: string = '') => {
  if (optName) optName = optName === '請選擇' ? '' : optName;
  setFieldValue(fieldName, optName);
};

/**
 * @description 判斷車主 ID 是否與登入 ID 相符，不同則顯示訊息
*/
const validOwnerMathLoginID = (ownerId: string, loginId: string, msg: string) => {
  if (!ownerId || !loginId || ownerId === loginId) return false;

  sweetAlertService.modal({
    icon: SweetAlertIcon.Info,
    html: msg,
    showConfirmButton: true
  });

  return true;
};

/**
 * @description 取得汽機車險保費
*/
const getVehiclePrenium = (sumPrenium: any, sumPreniumCI: any) => {
  let res = 0;
  if (sumPrenium) {
    res += sumPrenium;
  }

  if (sumPreniumCI) {
    res += sumPreniumCI;
  }

  return res;
};

/**
* @description 信用卡欄位填寫完成自動跳
*/
const setInputAutoFocus = (currentId: string, nextId: string) => {
  const currentInput = document.getElementById(currentId) as HTMLInputElement;
  const nextInput = document.getElementById(nextId) as HTMLInputElement;

  if (!currentInput || !nextInput) return;

  if (!currentInput.value || currentInput.value.length < currentInput.maxLength) return;

  if (currentInput.value.length === currentInput.maxLength && !nextInput.value) {
    setTimeout(() => {
      nextInput.focus();
    }, 50);
  }
};

/**
 * @description 暫存資料
 * @param storageKey 暫存的 key 值
 * @param tempData 要暫存的資料
*/
const storageData = (storageKey: storageKeys, tempData: any) => {
  // 資料類型為字串
  if (tempData && typeof tempData === 'string') {
    storageService.setItem(storageKey, tempData);
    return;
  }

  // 資料類型為物件
  if (tempData && typeof tempData === 'object' && Object.keys(tempData).length > 0) {
    // 設定過期時間為 6 小時後
    const newTempData = {
      ...tempData,
      expiredDate: moment().add(6, 'h')
    };

    storageService.setItem(storageKey, JSON.stringify(newTempData));

    return;
  }

  storageService.setItem(storageKey, JSON.stringify(tempData));
};

/**
 * @description 呼叫 API 用的 Body 資料
 * @param tranRQ Request Body 資訊
 * @param paginationRQ 分頁資訊
*/
const getApiReqData = (tranRQ?: any, paginationRQ?: any) => {
  const baseReq: BaseReq<any> = {
    MWHEADER: {
      ...paginationRQ
      // ApplicationId: ApplicationId.FrontEnd
    },
    TRANRQ: { ...tranRQ }
  };

  return baseReq;
};

/**
 * @description 呼叫 API 用的 Config 資料
*/
const getReqConfig = (applicationId: string = ApplicationId.FrontEnd) => {
  const reqConfig: AxiosRequestConfig = {
    headers: {
      ApplicationId: applicationId
    }
  };

  return reqConfig;
};

/**
 * @description 設定使用中的商品代碼
 */
const setActiveProdId = (insTypeId: string, prodId: string = '', programId: string = '') => {
  let storageKey;
  switch (insTypeId) {
    case InsType.Travel:
      storageKey = storageKeys.TravelActiveProdId;
      break;
    case InsType.Car:
      storageKey = storageKeys.CarActiveProdId;
      break;
    case InsType.Moto:
      storageKey = storageKeys.MotoActiveProdId;
      break;
    case InsType.Fire:
      storageKey = storageKeys.FireActiveProdId;
      break;
    case InsType.MobileDevice:
      storageKey = storageKeys.MobileDeviceActiveProdId;
      break;
    case InsType.Pet:
      storageKey = storageKeys.PetActiveProdId;
      break;
  }

  const temp: InsureProcessTemp = {
    INS_TYPE_ID: insTypeId,
    PROD_ID: prodId,
    PROGRAM_ID: programId
  };

  storageService.setItem(storageKey as storageKeys, JSON.stringify(temp));
};

/**
 * @description 取得完整地址
 */
const getFullAddress = (
  postCode: string = '', cityName: string = '', areaName: string = '', streetName: string = '', roadway: string = '',
  alley: string = '', number: string = '', numberOf: string = '', floor: string = '', floorOf: string = '',
  remark: string = ''
) => {
  // 取得完整地址
  let fullAddress = `${postCode}${cityName}${areaName}${streetName}`;
  if (roadway) {
    fullAddress = `${fullAddress}${roadway}巷`;
  }

  if (alley) {
    fullAddress = `${fullAddress}${alley}弄`;
  }

  if (number && numberOf) {
    fullAddress = `${fullAddress}${number}之${numberOf}號`;
  }

  if (number && !numberOf) {
    fullAddress = `${fullAddress}${number}號`;
  }

  if (floor) {
    fullAddress = `${fullAddress}${floor}樓`;
  }

  if (floorOf) {
    fullAddress = `${fullAddress}之${floorOf}`;
  }

  if (remark) {
    fullAddress = `${fullAddress}(${remark})`;
  }

  return fullAddress;
};

/*
 * @description 取得縣市名稱
 */
const getCityName = (postCodes: Postcode[], cityId: string | undefined) => {
  if (!postCodes || postCodes.length === 0) return '';

  const postCode = _.find(postCodes, (postCode: Postcode) => postCode.CITY_ID === cityId);
  if (!postCode) return '';

  return postCode.CITY_NAME;
};

/**
 * @description 取得區域名稱
 */
const getAreaName = (postCodes: Postcode[], cityId: string | undefined, areaId: string | undefined) => {
  if (!postCodes || postCodes.length === 0) return '';

  const postCode = _.find(postCodes, (postCode: Postcode) => postCode.CITY_ID === cityId);
  if (!postCode) return '';

  const area = _.find(postCode.AREA, (area: AreaContent) => area.AREA_ID === areaId);
  if (!area) return '';

  return area.AREA_NAME;
};

/**
 * @description 取得條款基本設置
 */
const getInitTermStatus = (contracts: any[]) => {
  if (!contracts || contracts.length === 0) return new Array(0);

  return _.map(contracts, (contract: any, index: number): TermStatus => {
    return {
      IS_ACTIVE: false,
      IS_BOTTOM: false,
      INDEX: index
    };
  });
};

/**
 * @description 設定 PDF 條款是否開啟
*/
const setPDFOpen = (index: number, termStatus: TermStatus[]) => {
  const term = _.find(termStatus, (status: any) => status.INDEX === index);
  if (!term) return;

  return term.IS_ACTIVE;
};

/**
 * @description 設定 PDF 條款是否可勾選
*/
const setPDFCheckable = (index: number, termStatus: TermStatus[]) => {
  const term = _.find(termStatus, (status: any) => status.INDEX === index);
  if (!term) return;

  return !term.IS_BOTTOM;
};

/**
 * @description 更新條款狀態
 */
const updateTermStatus = (checked: boolean, index: number, termStatus: TermStatus[]) => {
  return _.map(termStatus, (status: any) => {
    const self = status.INDEX === index;
    let isActive = status.IS_ACTIVE;

    if (checked && self) {
      isActive = true;
    }

    if ((checked && !self) || (!checked && self)) {
      isActive = false;
    }

    return {
      ...status,
      IS_ACTIVE: isActive
    };
  });
};

/**
 * @description 更新條款狀態
 */
const headerClickUpdateTermStatus = (checked: boolean, index: number, termStatus: TermStatus[]) => {
  return _.map(termStatus, (status: any) => {
    if (status.INDEX === index) {
      return {
        ...status,
        IS_ACTIVE: checked
      };
    }

    return status;
  });
};

/**
 * @description 更新條款滾動狀態
 */
const headerScrollUpdateTermStatus = (bottom: boolean, index: number, termStatus: TermStatus[]) => {
  return _.map(termStatus, (status: any) => {
    if (status.INDEX === index) {
      return {
        ...status,
        IS_BOTTOM: bottom
      };
    }

    return status;
  });
};

/**
 * @description 重設條款狀態
 */
const resetTermStatus = (termStatus: TermStatus[]) => {
  return _.map(termStatus, (status: any) => {
    return {
      ...status,
      IS_ACTIVE: false
    };
  });
};

/**
 * @description 格式化 UTC 時間為 +8 小時（毫秒）
 */
const formatUtcTime = (timeVal: any) => {
  return moment(timeVal).utcOffset(480);
};

/**
 * @description 檢核會員資料是否正常
 */
const checkMemberInfoError = (memberProfile?: MemberProfile) => {
  // 無會員資料不檢核
  if (!memberProfile) return false;

  // 無手機或 email 為檢核不過
  if (!memberProfile.MOBILE || !memberProfile.EMAIL_ADDR) return true;

  // 檢核手機、 email 是否符合規範內容
  return !mobileRegex.test(memberProfile.MOBILE) || !emailRegex.test(memberProfile.EMAIL_ADDR);
};

/**
 * @description 手機號碼格式化 xxxx-xxx-xxx
 */
const formatMobileNumAddDash = (str?: string) => {
  if (!str) return '-';

  return str.replace(/([\d]{4})([\d]{3})([\d]{3})/, '$1-$2-$3');
};

/**
 * @description 格式化空值或無值顯示 - 符號
 */
const formatNullToDash = (str?: string) => {
  if (!str) return '-';

  return str;
};

/**
 * @description 隱藏字串 (字元轉 * 號)
 */
const hiddenStringCharacters = (str?: string | null) => {
  if (!str) return '';
  return str.replace(/./g, '*');
};

/**
 * @description 隱藏字串後面幾碼 (字元轉 * 號)
 */
const hiddenStringLastCharacter = (str: string, charAmt?: number) => {
  if (charAmt) {
    const showChar = str.slice(0, charAmt * -1);
    const hiddenChar = [...Array(Math.abs(charAmt))].map(() => '*').join('');
    return showChar + hiddenChar;
  } else {
    return str.replace(/./g, '*');
  }
};

/**
 * @description 隱藏字串部分字元 (字元轉 * 號)
 */
const hiddenStringCharactersByIndexRange = (str: string, startIndex: number, endIndex: number) => {
  if (startIndex < str.length && endIndex <= str.length) {
    const hiddenChars = [...Array(endIndex - startIndex)].map(() => '*').join('');
    return str.substring(0, startIndex) + hiddenChars + str.substring(endIndex);
  } else if (startIndex < str.length && endIndex > str.length) {
    const hiddenChars = [...Array(str.length - startIndex)].map(() => '*').join('');
    return str.substring(0, startIndex) + hiddenChars + str.substring(str.length);
  } else {
    return str;
  }
};

/**
 * @description 將數字轉為 X萬
 */
const handleConvertAmount = (amount: string) => {
  if (parseInt(amount) < 10000) {
    return amount;
  } else {
    return parseInt(amount) / 10000 + '萬';
  }
};

/**
 * @description 校準至當前系統時間(伺服器時間)
 */
const normalizeTime = (strDate: string, sysTimeMs: number) => {
  const normailzedTime = moment.unix(sysTimeMs).format('HH:mm:ss');
  // console.log(normailzedTime);
  return moment(`${strDate} ${normailzedTime}`);
};

/**
  * @description 根據語系取得語系包對應文字
*/
const getNameByLng = (resources: ResourcesState, fid: string) => {
  const { lng, locales } = resources;
  // console.log('語系包', locales);
  const locale = locales[lng];
  if (locale && fid) {
    return locale[fid] ?? fid;
  }
  return fid;
};

/**
 * @description 根據語系取得語系包對應金額單位
 */
const getPriceUnitByLng = (resources: ResourcesState) => {
  let unit = '';
  if (resources.lng === 'zh') unit = '元';
  return unit;
};

/**
 * @description 取得前端商品連動規則
 */
const getFrontendRule = (ruleId: string) => {
  return frontendRules.find(it => it.ruleId === ruleId);
};

/**
 * @description 轉換圖片名稱為 Url
 */
const convertImageUrl = (imgName: string) => {
  const imgBaseUrl = store.getState().system.urlSysOpts.find(it => it.PARAM_ID === 'BASE_URL_IMAGES');
  if (imgBaseUrl) {
    // 判斷是否為 url
    if (imgName.startsWith('http://') || imgName.startsWith('https://')) return imgName;
    return `${imgBaseUrl.PARAM_VALUE}${imgName}`;
  }
  return imgName;
};

/**
 * @description 產生uuid
 */
const uuidv4 = () => {
  return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, c =>
    (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
  );
};

/**
 * @description 解析日期格式
 */
const parseDate = (val: string) => {
  if (!val) return '';
  const year = val.substring(0, 4);
  const month = val.substring(4, 6);
  const date = val.substring(6, 8);
  return `${year}/${month}/${date}`;
};

/**
 * @desctription 轉換金額格式
 */
const amountFormat = (value: Number) => {
  if (value === 0) return '-';
  if (value === 1000000) return (+value / 10000) + '萬';
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

/*
 * @description (源碼檢測) 清除 DOM 內 XSS 攻擊風險後，並將此文字轉為 html 結構
 */
const htmlParser = (htmlStr: string) => {
  return ReactHtmlParser(DOMPurify.sanitize(htmlStr));
};

/**
 * @desctription 分割廠代
 */
const splitCodeType = (codeType: string, gap: number = 0) => {
  if (!codeType) return [];
  const snippets = [];
  for (let i = 0; i < codeType.length; i += gap) {
    snippets.push(codeType.substring(i, i + gap));
  }
  return snippets;
};

/**
 * @description 呈現時間格式 YYYY年MM月DD日HH時
 * @param time 日期時間 YYYY/MM/DD HH:mm:ss
 */
const displayADDateWithHour = (time: string) => {
  if (!time) return '';
  const spinnets = time.split(' ');
  const dateStr = spinnets[0];
  const dateSpinnets = dateStr.split('/');
  const timeStr = spinnets[1];
  const timeSpinets = timeStr.split(':');
  return `${dateSpinnets[0]}年${dateSpinnets[1]}月${dateSpinnets[2]}日${timeSpinets[0]}時`;
};

const redirectUrl = (url: string) => {
  const allowUrl = whiteUrls.find(it => it === url);
  if (allowUrl) {
    window.open(encodeURI(allowUrl), '_self');
  }
};

/**
 * @description 根據地區卡控之文字範本轉成可讀文字
 * @param template 文字範本
 * @param startTime 開始時間
 * @param endTime 結束時間
 * @param area 地區 (Optional)
 */
const getRuleText = (template: string, startTime: string, endTime: string, area?: string) => {
  if (!template || !startTime || !endTime) return '';
  let ret = template;
  const timeKeys = ['YEAR', 'MONTH', 'DAY', 'HOUR'];
  // 建立替換規則，key 與 value 的數量應該一樣，則可完成一對一關鍵字替換
  const replaceRules = [
    { prefix: '#', postfix: 'S', keys: timeKeys, values: convertTimeSnippets(startTime) },
    { prefix: '#', postfix: 'E', keys: timeKeys, values: convertTimeSnippets(endTime) }
  ];
  if (area) {
    replaceRules.push({ prefix: '#', postfix: '', keys: ['OFFAREA'], values: [area] });
  }
  replaceRules.forEach(rule => {
    rule.keys.forEach((key, index) => {
      // 將文字內組合的 pattern 換成對應數值
      const pattern = `{${rule.prefix}${key}${rule.postfix}}`;
      ret = ret.replace(pattern, rule.values[index]);
    });
  });
  return ret;
};

/**
 * @description 切割並依下列時間片段排序: ['年', '月', '日', '時']
 * @param text 日期時間文字 YYYY/MM/DD HH:mm:ss
 */
const convertTimeSnippets = (text: string): string[] => {
  if (!text) return [];
  let retSnippets: string[] = [];
  const snippets = text.split(' ');
  if (snippets.length < 2) {
    // 僅日期，回傳 ['年', '月', '日']
    if (text.includes('/')) {
      return text.split('/');
    }
    // 僅時間，回傳 ['時']
    if (text.includes(':')) {
      return [text.split(':')[0]];
    }
    return [];
  }
  const dateStr = snippets[0];
  const dateSnippets = dateStr.split('/');
  const timeStr = snippets[1];
  const timeSnippets = timeStr.split(':');
  retSnippets = [...dateSnippets, timeSnippets[0]];
  return retSnippets;
};

/**
 * @description 篩選非一般職業選項
 */
const filterOccupationOpts = (occupations: Occupation[]) => {
  return occupations.map((item: Occupation) => {
    if (item.OCCUPATION_DOMAIN_ID === OccupationIdType.Special) {
      return ({
        ...item,
        OCCUPATION: item.OCCUPATION.filter(item => (+item.OCCUPATION_ID >= 101 && +item.OCCUPATION_ID <= 115) || item.OCCUPATION_ID === '999').sort((first, second) => +first.OCCUPATION_ID - +second.OCCUPATION_ID)
      });
    }
    return item;
  });
};

export default {
  isHttpRespSuccess,
  validLoginState,
  getLinkTarget,
  validRedirect,
  matchFavorite,
  getFavoriteItemSN,
  getAddFavoriteItem,
  sortSysOpts,
  downloadFile,
  expandEvalResult,
  getSubjectPClass,
  arrayTypeReturn,
  getCodeMsg,
  getSysOptText,
  scrollToTop,
  thousandFormat,
  removeComma,
  getDisableTime,
  showErrorModal,
  showAnnounceModal,
  setSelectOptName,
  validOwnerMathLoginID,
  getVehiclePrenium,
  setInputAutoFocus,
  storageData,
  getApiReqData,
  getReqConfig,
  setActiveProdId,
  getFullAddress,
  getCityName,
  getAreaName,
  getInitTermStatus,
  setPDFOpen,
  setPDFCheckable,
  updateTermStatus,
  resetTermStatus,
  headerClickUpdateTermStatus,
  headerScrollUpdateTermStatus,
  formatUtcTime,
  checkMemberInfoError,
  formatMobileNumAddDash,
  formatNullToDash,
  hiddenStringCharacters,
  hiddenStringLastCharacter,
  hiddenStringCharactersByIndexRange,
  handleConvertAmount,
  normalizeTime,
  getNameByLng,
  getPriceUnitByLng,
  getFrontendRule,
  convertImageUrl,
  uuidv4,
  parseDate,
  amountFormat,
  htmlParser,
  splitCodeType,
  displayADDateWithHour,
  getRuleText,
  redirectUrl,
  filterOccupationOpts
};
